import React, { useState } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter, Route, Switch } from "react-router-dom";

import theme from './ui/Theme';
import Header from './ui/Header';
import Footer from './ui/Footer';
import Index from './Index';
import Services from './Services';
import Network from './Network';
import Hardware from './Hardware';
import Learn from './Learn';
import About from './About';
import Contact from './Contact';
import Notfound from './Notfound';

import Content from '../content';



function App() {
  const [value, setValue] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);

  //const [language, setLanguage] = useState("per");
  const language = "per";

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        {/* <Header value={value} setValue={setValue} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} /> */}
        <Header content={Content.persian} language={language} value={value} setValue={setValue} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} />
        <Switch>
          {/* <Route exact path="/" render={(props) => <LandingPage {...props} setValue={setValue} setSelectedIndex={setSelectedIndex} />} /> */}
          {/* <Route exact path="/services" render={(props) => <Services {...props} setValue={setValue} setSelectedIndex={setSelectedIndex} />} /> */}
          {/* <Route exact path="/about" render={(props) => <About {...props} setValue={setValue} setSelectedIndex={setSelectedIndex} />} /> */}
          {/* <Route exact path="/contact" render={(props) => <Contact {...props} setValue={setValue} setSelectedIndex={setSelectedIndex} />} /> */}

          <Route exact path="/" render={(props) => <Index {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />
          <Route exact path="/services" render={(props) => <Services {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />
          <Route exact path="/network" render={(props) => <Network {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />
          <Route exact path="/hardware" render={(props) => <Hardware {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />
          <Route exact path="/learn" render={(props) => <Learn {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />
          <Route exact path="/about" render={(props) => <About {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />
          <Route exact path="/contact" render={(props) => <Contact {...props} content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />

          <Route render={(props) => <Notfound {...props} setValue={setValue} setSelectedIndex={setSelectedIndex} />} />

        </Switch>
        {/* <Footer setValue={setValue} setSelectedIndex={setSelectedIndex} /> */}
        <Footer content={Content.persian} language={language} setValue={setValue} setSelectedIndex={setSelectedIndex} />

      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
